/* eslint-disable */
import cronstrue from 'cronstrue';

xplenty.controller('StepsController', [
  '$scope',
  '$animateCss',
  '$timeout',
  '$translate',

  function ($scope, $animateCss, $timeout, $translate) {
    $scope._steps = [];
    $scope.animate = false;
    if ($scope.schedule) {
      $scope.schedule.schedule_message = ' ';
      $scope.schedule.cron_validity = true;
    }

    $scope.addStep = function (index, scope, element) {
      _.each($scope._steps, function (step) {
        step.scope.step.isLast = false;
      });
      scope.step.isLast = true;
      $scope._steps[index] = {
        scope,
        element,
      };
    };

    $scope.stepsCount = function () {
      return $scope._steps.length;
    };

    $scope.getPrevIndex = function (currentIndex) {
      let prevIndex = currentIndex - 1;
      (function checkNext() {
        if ($scope._steps[prevIndex] != undefined && $scope._steps[prevIndex].scope.step.lock) {
          prevIndex--;
          checkNext();
        }
      })();
      return prevIndex;
    };

    $scope.getNextIndex = function (currentIndex) {
      let nextIndex = currentIndex + 1;
      (function checkNext() {
        if ($scope._steps[nextIndex] != undefined && $scope._steps[nextIndex].scope.step.lock) {
          nextIndex++;
          checkNext();
        }
      })();
      return nextIndex;
    };

    $scope.setActive = function (index, active, animate) {
      if (active) {
        for (const _index in $scope._steps) {
          if (index != parseInt(_index)) {
            var step = $scope._steps[_index];
            if (step.scope.step.active) $scope.setActive(_index, false, animate);
          }
        }
      }

      animate = animate == undefined ? true : animate;

      var step = $scope._steps[index];
      if (!step) {
        return;
      }
      const $stepBody = step.element.find('.step-body');
      const $stepBodyContainer = $stepBody.find('.step-body-container');
      const $stepButtons = $stepBody.find('.step-buttons');

      const bodyHeight = $stepBodyContainer.outerHeight() + $stepButtons.outerHeight();
      const duration = 0.75;

      step.scope.step.active = active;

      if (animate) {
        $scope.animate = true;

        if (active) {
          $animateCss($stepBody, {
            from: { height: '0px' },
            to: { height: `${bodyHeight}px` },
            easing: 'cubic-bezier(0, 1, 0.5, 1)',
            duration,
          })
            .start()
            .then(function () {
              $stepBody.addClass('visible');
              $scope.animate = false;
              // var $firstInput = $stepBody.find('input').first();
              // $timeout(function () {
              //     $firstInput.focus();
              // }, 100);
            });
        } else {
          $stepBody.removeClass('visible');
          $animateCss($stepBody, {
            from: { height: `${bodyHeight}px` },
            to: { height: '0px' },
            easing: 'cubic-bezier(0, 1, 0.5, 1)',
            duration,
          })
            .start()
            .then(function () {
              $scope.animate = false;
            });
        }
      } else {
        $stepBody.height(active ? bodyHeight : 0);
        $stepBody[active ? 'addClass' : 'removeClass']('visible');
      }
    };

    $scope.resetCronValidity = function (valid) {
      if ($scope.scheduleForm) {
        $scope.schedule.cron_validity = valid;
        $scope.scheduleForm.cron.$setValidity('cron', valid);
      }
    };

    $scope.setFrequencyMessage = function () {
      $scope.schedule.schedule_message = '';
      try {
        $scope.schedule.schedule_message = cronstrue.toString($scope.schedule.schedule_expression.toUpperCase());
        $scope.resetCronValidity(true);
      } catch (e) {
        $scope.resetCronValidity(false);
      }
    };

    $scope.validateCron = function () {
      if (
        $scope.schedule.schedule_expression &&
        $scope.schedule.schedule_message &&
        $scope.schedule.schedule_message !== $translate.instant('Schedule.labels.invalid_cron_message')
      ) {
        const parsed_expression = $scope.schedule.schedule_expression.toUpperCase().split(' ');
        const cronIsValid = !(
          $scope.schedule.schedule_message.contains('undefined') ||
          !validateCronValues(parsed_expression) ||
          parsed_expression.length > 5 ||
          parsed_expression.length < 0 ||
          parsed_expression.includes('?')
        );

        if (cronIsValid) {
          $scope.resetCronValidity(true);
        } else {
          $scope.resetCronValidity(false);
          $scope.schedule.schedule_message = $translate.instant('Schedule.labels.invalid_cron_message');
        }
      } else {
        $scope.resetCronValidity(false);
        if ($scope.schedule.schedule_expression && $scope.schedule.schedule_expression.length > 0) {
          $scope.schedule.schedule_message = $translate.instant('Schedule.labels.invalid_cron_message');
        }
      }
    };

    // validating on months and week days is provided by cronstrue
    function validateCronValues(parsed_expression) {
      const validateMinutes = validateValue(parsed_expression[0], 0, 59);
      const validateHours = validateValue(parsed_expression[1], 0, 23);
      const validateDays = validateValue(parsed_expression[2], 1, 31) || parsed_expression[2] == 'L';
      const validateMonthDays = validateMonthDaysValues(parsed_expression[2], parsed_expression[3]);
      const validateWeekDays = validateWeekDaysValues(parsed_expression[4]);

      return validateMinutes && validateHours && validateDays && validateMonthDays && validateWeekDays;
    }

    function validateValue(value, down, up) {
      if (parseInt(value) == value && value.match(/^[0-9]+$/) != null) {
        return checkIntegerValue(value, down, up);
      }
      if (value.toString().contains('-')) {
        return checkRangeValues(value, down, up);
      }
      if (value.toString().contains(',')) {
        return checkSequenceValues(value, down, up);
      }
      if (value.toString().contains('/')) {
        return checkPeriodValues(value, down, up);
      }
      return value == '*';
    }

    function checkIntegerValue(value, down, up) {
      return /^\d+$/.test(value) && value >= down && value <= up;
    }

    function checkRangeValues(value, down, up) {
      const parsed_value = parseSplitArrayToInt(value, '-');
      return checkIntegerValue(parsed_value[0], down, up) && checkIntegerValue(parsed_value[1], down, up);
    }

    function checkPeriodValues(value, down, up) {
      const parsed_value = value.split('/');
      return (
        (checkIntegerValue(parseInt(parsed_value[0]), down, up) || parsed_value[0] == '*') &&
        checkIntegerValue(parseInt(parsed_value[1]), down, up)
      );
    }

    function validateWeekDaysValues(value) {
      const daysNames = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN', '*'];
      const daysNumbers = ['1', '2', '3', '4', '5', '6', '7', '*'];

      if (value.length > 0) {
        let result = true;
        value.split(/,|-/).forEach(function (element) {
          result = result && (daysNumbers.includes(element) || daysNames.includes(element));
        });
        return result;
      }
      return false;
    }

    function validateMonthDaysValues(days, months) {
      const monthDayHash = {
        JAN: 31,
        FEB: 29,
        MAR: 31,
        APR: 30,
        MAY: 31,
        JUN: 30,
        JUL: 31,
        AUG: 31,
        SEP: 30,
        OCT: 31,
        NOV: 30,
        DEC: 31,
        1: 31,
        2: 29,
        3: 31,
        4: 30,
        5: 31,
        6: 30,
        7: 31,
        8: 31,
        9: 30,
        10: 31,
        11: 30,
        12: 31,
        '*': 31,
      };

      if (months.length > 0 && days.length > 0) {
        let result = true;
        splitValues(months).forEach(function (month) {
          splitValues(days).forEach(function (day) {
            result = result && ((day > 0 && day <= monthDayHash[month]) || day == '*' || day == 'L');
          });
        });
        return result;
      }
      return false;
    }

    function splitValues(values) {
      if (values.contains(',')) {
        return values.split(',');
      }
      if (values.contains('-')) {
        return values.split('-');
      }
      return values.split();
    }

    function checkSequenceValues(value, down, up) {
      let result = true;
      const parsed_value = parseSplitArrayToInt(value, ',');
      parsed_value.forEach(function (element) {
        result = result && checkIntegerValue(element, down, up);
      });
      return result;
    }

    function parseSplitArrayToInt(value, split) {
      return value.split(split).map(function (element) {
        return parseInt(element);
      });
    }
  },
]);
